import styled, { css } from 'styled-components';

const buttonVariants = {
  primary: css`
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.text.inverse};
    border: 1px solid ${props => props.theme.colors.primary};

    &:hover:not(:disabled) {
      background-color: ${props => props.theme.colors.primaryHover};
      border-color: ${props => props.theme.colors.primaryHover};
    }
  `,
  secondary: css`
    background-color: transparent;
    color: ${props => props.theme.colors.text.primary};
    border: 1px solid ${props => props.theme.colors.border.medium};

    &:hover:not(:disabled) {
      background-color: ${props => props.theme.colors.background.secondary};
      border-color: ${props => props.theme.colors.border.dark};
    }
  `,
  outline: css`
    background-color: transparent;
    color: ${props => props.theme.colors.primary};
    border: 1px solid ${props => props.theme.colors.primary};

    &:hover:not(:disabled) {
      background-color: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.text.inverse};
    }
  `,
  danger: css`
    background-color: ${props => props.theme.colors.error};
    color: ${props => props.theme.colors.text.inverse};
    border: 1px solid ${props => props.theme.colors.error};

    &:hover:not(:disabled) {
      background-color: #b91c1c;
      border-color: #b91c1c;
    }
  `,
};

const buttonSizes = {
  sm: css`
    padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
    font-size: ${props => props.theme.fontSize.xs};
  `,
  md: css`
    padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg};
    font-size: ${props => props.theme.fontSize.sm};
  `,
  lg: css`
    padding: ${props => props.theme.spacing.lg} ${props => props.theme.spacing.xl};
    font-size: ${props => props.theme.fontSize.base};
  `,
};

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.md};
  font-weight: ${props => props.theme.fontWeight.medium};
  text-decoration: none;
  cursor: pointer;
  transition: all ${props => props.theme.transitions.fast};
  white-space: nowrap;
  
  ${props => buttonVariants[props.variant || 'primary']}
  ${props => buttonSizes[props.size || 'md']}
  
  ${props => props.fullWidth && css`
    width: 100%;
  `}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  &:focus {
    outline: 2px solid ${props => props.theme.colors.primaryLight};
    outline-offset: 2px;
  }
`;

export default Button;